import React from "react";
import { ArrowRight, ArrowDown } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1643817602409-91b7573a6f9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxjYXVjYXN1cyUyMG1vdW50YWlucyUyMG1vb2R5fGVufDB8fHx8MTc4MTc4MTgzNHww&ixlib=rb-4.1.0&q=85";

export const Hero = ({ t }) => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_IMG}
          alt="Caucasus mountain road, moody"
          className="w-full h-full object-cover slow-zoom"
          style={{ filter: "saturate(0.85) brightness(0.7)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#110F0E] via-[#110F0E]/55 to-[#110F0E]/25" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#110F0E]/70 via-transparent to-transparent" />
      </div>

      {/* Top side meta */}
      <div className="absolute top-28 right-6 md:right-12 lg:right-16 z-10 hidden md:block text-right fade-up">
        <p className="overline">N°01 / Winter / 2026</p>
        <p className="overline mt-2">42.7°N · 44.5°E</p>
      </div>

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col justify-end px-6 md:px-12 lg:px-16 pb-20 md:pb-28">
        <div className="max-w-5xl fade-up">
          <p data-testid="hero-overline" className="overline mb-6 md:mb-8">{t.hero.overline}</p>
          <h1
            data-testid="hero-title"
            className="font-serif font-light text-[#F3EFE9] text-5xl sm:text-6xl md:text-7xl lg:text-[112px] leading-[0.95] tracking-tight"
          >
            {t.hero.title_l1}
            <br />
            <span className="italic text-[#A67A53]">{t.hero.title_l2}</span>
          </h1>
          <p
            data-testid="hero-sub"
            className="mt-8 md:mt-10 max-w-xl text-[#F3EFE9]/80 text-base md:text-lg font-light leading-relaxed"
          >
            {t.hero.sub}
          </p>

          <div className="mt-10 md:mt-14 flex flex-wrap items-center gap-4">
            <button
              data-testid="hero-cta-primary"
              onClick={() => scrollTo("collection")}
              className="btn-primary"
            >
              {t.hero.cta_primary}
              <ArrowRight size={14} strokeWidth={1.5} />
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={() => scrollTo("heritage")}
              className="btn-outline"
            >
              {t.hero.cta_secondary}
            </button>
          </div>
        </div>

        {/* Bottom scroll indicator */}
        <div className="absolute bottom-6 right-6 md:right-12 lg:right-16 hidden md:flex items-center gap-3 text-[#9D9287]">
          <span className="overline">Scroll</span>
          <ArrowDown size={14} className="animate-bounce" />
        </div>
      </div>
    </section>
  );
};
